import { WaypointCategoryEnum } from "../../enums";
import { IRoutingWaypointStationRow } from "../../models";
import { isStationRouteWaypointStation } from "../routing-waypoint";

/**
 * Customized ML paths only store MLPathWaypoint rows. Ride/course user-owned
 * waypoints are re-stamped when transferring from a ride into a station route.
 */
export const stampRoutingWaypointsAsMlPath = <
  T extends IRoutingWaypointStationRow,
>(
  stations: T[] | undefined,
): T[] =>
  (stations ?? []).map(station =>
    isStationRouteWaypointStation(station)
      ? { ...station, waypointCategory: WaypointCategoryEnum.MLPathWaypoint }
      : station,
  );
